import EventEmitter from 'eventemitter3';
var emitterCache;
function getEmitter() {
  if (!emitterCache) {
    emitterCache = new EventEmitter();
  }
  return emitterCache;
}
export function addListener(callback) {
  var emitter = getEmitter();
  emitter.addListener('CalendarScroll', callback);
  return {
    remove: function remove() {
      emitter.removeListener('CalendarScroll', callback);
    }
  };
}
export function emit() {
  getEmitter().emit('CalendarScroll');
}